import { IconButton } from '@material-ui/core';
import React from 'react';
// import styled from 'styled-components/macro';

const CustomIconButton = ({ children, style, ...rest }) => {
    return (
        <IconButton size={'small'} style={{ color: '#272727', ...style }} {...rest}>
            {children}
        </IconButton>
    );
};

export default CustomIconButton;
